export const SEND_INVOICE_TO_REGISTERED_EMAIL = "invoice/SEND_INVOICE_TO_REGISTERED_EMAIL";
export const SEND_INVOICE_TO_REGISTERED_EMAIL_SUCCESS = "invoice/SEND_INVOICE_TO_REGISTERED_EMAIL_SUCCESS";
export const SEND_INVOICE_TO_REGISTERED_EMAIL_FAIL = "invoice/SEND_INVOICE_TO_REGISTERED_EMAIL_FAIL";
export const SEND_INVOICE_TO_NEW_EMAIL = "invoice/SEND_INVOICE_TO_NEW_EMAIL";
export const SEND_INVOICE_TO_NEW_EMAIL_SUCCESS = "invoice/SEND_INVOICE_TO_NEW_EMAIL_SUCCESS";
export const SEND_INVOICE_TO_NEW_EMAIL_FAIL = "invoice/SEND_INVOICE_TO_NEW_EMAIL_FAIL";
